import { useToast } from '@color/continuum';

import {
  useCreateVariantConfirmationRequestMutation,
  useUpdateVariantConfirmationMutation,
} from '../api';

import { ConfirmationDraft } from './draftUtils';

export function useSubmitVariantConfirmationRequests(options: {
  onSuccessAfterSubmit: () => void;
}) {
  const { onSuccessAfterSubmit } = options;
  const { showToast } = useToast();

  const { mutateAsync: updateConfirmation, isPending: isUpdating } =
    useUpdateVariantConfirmationMutation({ invalidateList: false });
  const { mutateAsync: createRequest, isPending: isRequesting } =
    useCreateVariantConfirmationRequestMutation();

  const isLoading = isUpdating || isRequesting;

  const submitDrafts = async (drafts: ConfirmationDraft[]) => {
    try {
      await Promise.all(
        drafts.map((draft) =>
          updateConfirmation({
            id: draft.id,
            method: draft.method,
            vendor: draft.vendor,
            use_double_dna: draft.use_double_dna,
            method_vendor_set: true,
          })
        )
      );
      await createRequest({ variant_confirmations: drafts.map((d) => d.id) });
      showToast(
        drafts.length === 1
          ? 'Variant confirmation request sent.'
          : 'Variant confirmation requests sent.',
        { severity: 'success' }
      );
      onSuccessAfterSubmit();
    } catch {
      // mutateAsync rethrows even when onError is defined; catch here to prevent
      // an unhandled rejection. Error toasts are shown by the mutation hooks.
    }
  };

  return { submitDrafts, isLoading };
}
